import { createSvgComponent } from "../../icon/createSvgComponent";
import Pin from "@core/icon/assets/pin.svg";
export default createSvgComponent(Pin);